import Commentary from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/commentary'
import CorporateLinkageScoreTable from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/corporateLinkageScore/CorporateLinkageScoreTable'
import { getLinkageScoreThunk } from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/corporateLinkageScore/store/thunk'
import CorporateRiskScoreContent from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/corporateRiskScore/CorporateRiskScoreContent'
import DistributionOfScoreChart from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/distributionOfScore/DistributionOfScoreChart'
import DistributionOfScoreTable from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/distributionOfScore/DistributionOfScoreTable'
import ForwardLookingPDTermStructureContent from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/forwardLookingPDTermStructure/ForwardLookingPDTermStructureContent'
import { parseValueToParams } from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/helper'
import RiskComponentAnalysisDynamic from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/riskComponentAnalysis/RiskComponentAnalysisDynamic'
import SelectTimeRiskComponentAnalysis from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/riskComponentAnalysis/SelectTimeRiskComponentAnalysis'
import { TableRiskScaleAndInterpretation } from '../../../../companyAnalysis/score/corporateRiskScore/components/bottomComponent/components/riskScaleAndInterpretation/TableRiskScaleAndInterpretation'
import {
  getBreakdownCompareThunk,
  getBreakdownThunk,
  getCommentaryThunk,
  getDistributionScoreThunk,
  getHistoricalChangeDrdDataThunk,
  getHistoricalChangeThunk,
  getPDTermStructureThunk,
  getRiskDriverCompareThunk,
  getRiskDriverDataThunk,
  getRiskScaleInterpretationThunk,
} from '../../../../companyAnalysis/score/corporateRiskScore/store/thunk'
import { getHighlight } from '../../../../companyAnalysis/score/store/thunk'
import { COMPANY_TYPES } from '../../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'

const PANELS = {
  RISK_SCALE_AND_INTERPRETATION: 'riskScaleAndInterpretation',
  CORPORATE_RISK_SCORE: 'corporateRiskScore',
  RISK_COMPONENT_ANALYSIS: 'riskComponentAnalysis',
  COMMENTARY: 'commentary',
  FORWARD_LOOKING_PD_TERM_STRUCTURE: 'forwardLookingPdTermStructure',
  DISTRIBUTION_OF_SCORE: 'distributionOfScore',
  CORPORATE_LINKAGE_SCORE: 'corporateLinkageScore',
}

export const getPanelListCorporateRiskScore = (companyType) => {
  if ([COMPANY_TYPES.BANK, COMPANY_TYPES.SECURITIES].includes(companyType)) {
    return []
  }
  return [
    {
      label: 'dynamicReport.CORPORATE_RISK_SCORE',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.RISK_SCALE_AND_INTERPRETATION,
          label: 'dynamicReport.RISK_SCALE_AND_INTERPRETATION',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.CORPORATE_RISK_SCORE,
          label: 'dynamicReport.CORPORATE_RISK_SCORE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.CHART,
            checked: ['score', 'historicalChange'],
            timeFrequency: 'Yearly',
            timeFrequencyScore: 'Yearly',
            checkedHistoricalChange: ['data1', 'data2', 'data3'],
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.RISK_COMPONENT_ANALYSIS,
          label: 'dynamicReport.RISK_COMPONENT_ANALYSIS',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.CHART,
            isCompare: false,
            timeFrequency: 'Yearly',
            checked: ['scoreBreakdown', 'relativeContributions'],
            basePeriod: null,
            comparisonPeriod: null,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.COMMENTARY,
          label: 'dynamicReport.COMMENTARY',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.FORWARD_LOOKING_PD_TERM_STRUCTURE,
          label: 'dynamicReport.FORWARD_LOOKING_PD_TERM_STRUCTURE',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.DISTRIBUTION_OF_SCORE,
          label: 'dynamicReport.DISTRIBUTION_OF_SCORE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.CHART,
            sortBy: 'modelSegment',
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].CORPORATE_RISK_SCORE,
          panel: PANELS.CORPORATE_LINKAGE_SCORE,
          label: 'dynamicReport.CORPORATE_LINKAGE_SCORE',
          type: TYPE_ITEM_SETTING.PANEL,
        },
      ],
    },
  ]
}

const PANEL_SETTING_CORPORATE_RISK_SCORE = [
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: 'score',
    key: 'checked',
    title: 'dynamicReport.SCORE',
    isInline: true,
    children: [
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Yearly',
        key: 'timeFrequencyScore',
        title: 'companyAnalysis.industryAnalysis.YEARLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Quarterly',
        key: 'timeFrequencyScore',
        title: 'companyAnalysis.industryAnalysis.QUARTERLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Monthly',
        key: 'timeFrequencyScore',
        title: 'companyAnalysis.industryAnalysis.MONTHLY',
      },
    ],
  },
  {
    type: TYPE_INFORMATION_PANEL.CHECKBOX,
    value: 'historicalChange',
    key: 'checked',
    title: 'corporateRiskScore.historicalChange',
    isInline: true,
    children: [
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Yearly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.YEARLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Quarterly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.QUARTERLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Monthly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.MONTHLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'data1',
        key: 'checkedHistoricalChange',
        title: 'corporateRiskScore.probabilityOfDefault',
        isBreakLine: true,
      },
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'data2',
        key: 'checkedHistoricalChange',
        title: 'corporateRiskScore.scoreCompany',
        isBreakLine: true,
      },
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'data3',
        key: 'checkedHistoricalChange',
        title: 'corporateRiskScore.scoreModelSegment',
        isBreakLine: true,
      },
    ],
  },
]

const PANEL_SETTING_DISTRIBUTION_OF_SCORE = [
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: 'modelSegment',
    key: 'sortBy',
    title: 'distributionOfScore.byModelSegment',
  },
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: 'industry',
    key: 'sortBy',
    title: 'distributionOfScore.byIndustry',
  },
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: 'companySize',
    key: 'sortBy',
    title: 'distributionOfScore.byCompanySize',
  },
]

const PANEL_SETTING_RISK_COMPONENT_ANALYSIS_CHART = [
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: false,
    key: 'isCompare',
    title: 'riskComponentAnalysis.lastestScore',
    children: [
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'scoreBreakdown',
        key: 'checked',
        title: 'riskComponentAnalysis.scoreBreakdown',
        isBreakLine: true,
      },
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'relativeContributions',
        key: 'checked',
        title: 'riskComponentAnalysis.relativeContributions',
        isBreakLine: true,
      },
    ],
  },
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: true,
    key: 'isCompare',
    title: 'riskComponentAnalysis.comparedData',
    isInline: true,
    children: [
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Yearly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.YEARLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Quarterly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.QUARTERLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Monthly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.MONTHLY',
      },

      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => {
          return (
            <SelectTimeRiskComponentAnalysis
              title="riskComponentAnalysis.basePeriod1"
              keySetting="basePeriod"
              {...other}
            />
          )
        },
      },
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => {
          return (
            <SelectTimeRiskComponentAnalysis
              title="riskComponentAnalysis.comparisonPeriod1"
              keySetting="comparisonPeriod"
              {...other}
            />
          )
        },
      },

      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'scoreBreakdown',
        key: 'checked',
        title: 'riskComponentAnalysis.scoreBreakdown',
        isBreakLine: true,
      },
      {
        type: TYPE_INFORMATION_PANEL.CHECKBOX,
        value: 'relativeContributions',
        key: 'checked',
        title: 'riskComponentAnalysis.relativeContributions',
        isBreakLine: true,
      },
    ],
  },
]

const PANEL_SETTING_RISK_COMPONENT_ANALYSIS_TABLE = [
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: false,
    key: 'isCompare',
    title: 'riskComponentAnalysis.lastestScore',
  },
  {
    type: TYPE_INFORMATION_PANEL.RADIO,
    value: true,
    key: 'isCompare',
    title: 'riskComponentAnalysis.comparedData',
    isInline: true,
    children: [
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Yearly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.YEARLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Quarterly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.QUARTERLY',
      },
      {
        type: TYPE_INFORMATION_PANEL.RADIO,
        value: 'Monthly',
        key: 'timeFrequency',
        title: 'companyAnalysis.industryAnalysis.MONTHLY',
      },

      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => {
          return (
            <SelectTimeRiskComponentAnalysis
              title="riskComponentAnalysis.basePeriod1"
              keySetting="basePeriod"
              {...other}
            />
          )
        },
      },
      {
        type: TYPE_INFORMATION_PANEL.NODE,
        renderItem: ({ key, ...other }) => {
          return (
            <SelectTimeRiskComponentAnalysis
              title="riskComponentAnalysis.comparisonPeriod1"
              keySetting="comparisonPeriod"
              {...other}
            />
          )
        },
      },
    ],
  },
]

export const getPanelCorporateRiskScore = (panel, setting) => {
  const { viewBy, timeFrequency, timeFrequencyScore } = setting
  switch (panel) {
    case PANELS.RISK_SCALE_AND_INTERPRETATION:
      return {
        renderComponent: () => {
          return <TableRiskScaleAndInterpretation isDynamicReport />
        },
        isWaitForMount: false,
        isTable: true,
        thunk: [() => getRiskScaleInterpretationThunk({})],
      }
    case PANELS.CORPORATE_RISK_SCORE:
      return {
        renderComponent: () => (
          <CorporateRiskScoreContent
            isDynamicReport
            settingDynamic={setting}
            viewBy={viewBy}
            filterTime={{
              basePeriod: null,
              comparisonPeriod: null,
              timeFrequency: timeFrequency,
            }}
          />
        ),
        width:
          timeFrequency === 'Monthly' && viewBy === VIEW_BY.TABLE
            ? 1000
            : undefined,
        thunk: [
          ({ companyInfo }) =>
            getHighlight({
              OrganizationId: companyInfo.organizationId,
              TimeFrequency: timeFrequencyScore,
            }),
          ({ companyInfo }) =>
            getHistoricalChangeThunk({
              OrganizationId: companyInfo.organizationId,
              TimeFrequency: timeFrequency,
            }),
          () => getRiskScaleInterpretationThunk({}),
        ],
        isWaitForMount: setting?.checked?.includes('historicalChange'),
        isTable: false,
        settingPanel: {
          viewByList: [VIEW_BY.CHART, VIEW_BY.TABLE],
          [VIEW_BY.CHART]: [...PANEL_SETTING_CORPORATE_RISK_SCORE],
          [VIEW_BY.TABLE]: [...PANEL_SETTING_CORPORATE_RISK_SCORE],
        },
      }
    case PANELS.RISK_COMPONENT_ANALYSIS:
      const { isCompare, checked, basePeriod, comparisonPeriod } = setting
      const fromParams = parseValueToParams(basePeriod, timeFrequency)
      const toParams = parseValueToParams(comparisonPeriod, timeFrequency)
      const showRelativeContributions =
        viewBy === 'Chart' && checked.includes('relativeContributions')
      const showRiskDriversTable = viewBy === 'Table'
      return {
        renderComponent: () => {
          return (
            <RiskComponentAnalysisDynamic
              isDynamicReport
              isCompare={isCompare}
              filterTime={{
                from: basePeriod,
                to: comparisonPeriod,
              }}
              arrValueDynamic={checked || []}
              viewBy={viewBy}
            />
          )
        },
        isTable: false,
        isWaitForMount: !!showRelativeContributions || showRiskDriversTable,
        thunk: isCompare
          ? [
              ({ companyInfo }) =>
                getHistoricalChangeDrdDataThunk({
                  OrganizationId: companyInfo.organizationId,
                }),
              ({ companyInfo }) =>
                getHighlight({
                  OrganizationId: companyInfo.organizationId,
                  TimeFrequency: timeFrequency,
                }),
              ({ companyInfo }) =>
                getBreakdownCompareThunk({
                  OrganizationId: companyInfo.organizationId,
                  TimeFrequency: timeFrequency,
                  BaseQuarter: fromParams.Quarter,
                  BaseYear: fromParams.Year,
                  BaseMonth: fromParams.Month,
                  CompareQuarter: toParams.Quarter,
                  CompareYear: toParams.Year,
                  CompareMonth: toParams.Month,
                }),
              ({ companyInfo }) =>
                getRiskDriverCompareThunk({
                  OrganizationId: companyInfo.organizationId,
                  TimeFrequency: timeFrequency,
                  BaseQuarter: fromParams.Quarter,
                  BaseYear: fromParams.Year,
                  BaseMonth: fromParams.Month,
                  CompareQuarter: toParams.Quarter,
                  CompareYear: toParams.Year,
                  CompareMonth: toParams.Month,
                }),
            ]
          : [
              ({ companyInfo }) =>
                getHighlight({
                  OrganizationId: companyInfo.organizationId,
                  TimeFrequency: timeFrequency,
                }),
              ({ companyInfo }) =>
                getBreakdownThunk({
                  OrganizationId: companyInfo.organizationId,
                  TimeFrequency: timeFrequency,
                }),
              ({ companyInfo }) =>
                getRiskDriverDataThunk({
                  OrganizationId: companyInfo.organizationId,
                }),
            ],
        settingPanel: {
          viewByList: [VIEW_BY.CHART, VIEW_BY.TABLE],
          [VIEW_BY.CHART]: [...PANEL_SETTING_RISK_COMPONENT_ANALYSIS_CHART],
          [VIEW_BY.TABLE]: [...PANEL_SETTING_RISK_COMPONENT_ANALYSIS_TABLE],
        },
      }
    case PANELS.COMMENTARY:
      return {
        renderComponent: () => {
          return <Commentary isDynamicReport />
        },
        isTable: false,
        isWaitForMount: false,
        thunk: [
          ({ companyInfo }) =>
            getCommentaryThunk({
              OrganizationId: companyInfo.organizationId,
              TimeFrequency: timeFrequency,
            }),
        ],
      }
    case PANELS.FORWARD_LOOKING_PD_TERM_STRUCTURE:
      return {
        renderComponent: () => {
          return (
            <ForwardLookingPDTermStructureContent
              isDynamicReport
              settingDynamic={setting}
            />
          )
        },
        isTable: true,
        thunk: [
          ({ companyInfo }) =>
            getPDTermStructureThunk({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
      }
    case PANELS.DISTRIBUTION_OF_SCORE:
      return {
        renderComponent: ({ setting: { viewBy, sortBy } }) => {
          if (viewBy === VIEW_BY.CHART) {
            return <DistributionOfScoreChart sortBy={sortBy} />
          }
          return <DistributionOfScoreTable isDynamicReport sortBy={sortBy} />
        },
        isTable: false,
        isWaitForMount: viewBy === VIEW_BY.CHART,
        thunk: [
          ({ companyInfo }) =>
            getDistributionScoreThunk({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        settingPanel: {
          viewByList: [VIEW_BY.CHART, VIEW_BY.TABLE],
          [VIEW_BY.CHART]: [...PANEL_SETTING_DISTRIBUTION_OF_SCORE],
          [VIEW_BY.TABLE]: [...PANEL_SETTING_DISTRIBUTION_OF_SCORE],
        },
      }
    case PANELS.CORPORATE_LINKAGE_SCORE:
      return {
        renderComponent: () => {
          return <CorporateLinkageScoreTable isDynamicReport />
        },
        width: 800,
        isTable: true,
        isWaitForMount: true,
        thunk: [
          ({ companyInfo }) =>
            getLinkageScoreThunk({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
      }
    default:
      break
  }
}
